import React from "react";
import { Divider } from "antd";
import { Hierarchy } from "./components/hierarchy/hierarchy.index";
import { LicensedStates } from "./components/licensedStates/licensedStates.index";
import { ProductsContracts } from "./components/productsContracts/productsContracts.index";
import styles from "./contractPanel.module.css";

export const ContractPanel = () => (
    <div className={styles.panel}>
        <div className={styles.licensedStatesCtn}>
            <LicensedStates />
        </div>
        <Divider className={styles.divider} />
        <div className={styles.productsContractsCtn}>
            <ProductsContracts />
        </div>
        <div className={styles.hierarchyCtn}>
            <Hierarchy />
        </div>
    </div>
);
